import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_FOUNDERS_START, DELETE_FOUNDERS_ERROR, DELETE_FOUNDERS_SUCCESS, GET_FOUNDERS_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/founders/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_FOUNDERS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_FOUNDERS_ERROR, error });
  } finally {
    yield put({ type: GET_FOUNDERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_founders() {
  yield takeLatest(DELETE_FOUNDERS_START, del);
}
